import Vue from 'vue'
import App from './App.vue'
import router from './router/m_pro'
import store from './store'
import Vant from 'vant'
import 'vant/lib/index.css';
import '../public/reset.css'
import '../public/iconfont.css'
Vue.use(Vant)


Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
